import React from 'react';
import AdminDashboard from '../components/AdminDashboard';
import ProtectedRoute from '../components/ProtectedRoute';

const Admin = () => {
    return (
        <ProtectedRoute>
            <div className="p-4">
                <AdminDashboard />
            </div>
        </ProtectedRoute>
    );
};

export default Admin;